import { RangeOption } from '../../types/Option/Option';

export function getLevelsRanges(data: any[], stopsCount: number) {
    // @ts-ignore
    const stops = [...Array(stopsCount).keys()];
    const sorted = data.slice().sort((a, b) => a - b);
    const range =
        sorted.length > 0 ? Math.max(sorted[sorted.length - 1], stopsCount) : 0;
    const periodPart = Math.round(range / stopsCount);
    const periodLength = Math.ceil(Math.log10(periodPart + 1)) || 1;
    const multiplier =
        periodLength > 1 ? Math.pow(10, periodLength - 1) / 2 : 1;
    const numbersRange = sorted[sorted.length - 1] - sorted[0];
    const step =
        Math.floor(numbersRange / (stops.length - 1) / multiplier) * multiplier;

    let fromValue = 0;

    const toValue = (i: number) => {
        if (i === 0) {
            fromValue = Math.ceil(sorted[0] / multiplier) * multiplier;
            return fromValue;
        } else if (i !== stops.length - 1) {
            fromValue += step;
            return fromValue;
        } else {
            return null;
        }
    };
    return stops.map((stop, i) => {
        return {
            from: fromValue,
            to: toValue(i),
        };
    });
}

export function getLevels(data: any[]): RangeOption[] {
    const stops = 4;
    const ranges = getLevelsRanges(data, stops);

    if (data.length === 0) {
        return [];
    }

    return ranges.map((range, index) => {
        if (!range.from && range.to)
            return {
                key: index + 1,
                displayName: `Under ${range.to}`,
                range,
            };

        const displayName =
            range.from + (range.to !== null ? ' - ' + range.to : '+');

        return {
            key: index + 1,
            displayName,
            range,
        };
    });
}
